import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSyncedUser } from '../../context/SyncedUserContext';
import Loader from '../ui/loader';

const RoleProtectedRoute = ({ children, requiredRole }) => {
  const { syncedUserData } = useSyncedUser();
  
  // Show loader while user data is being fetched
  if (!syncedUserData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }
  
  const userRole = syncedUserData?.user?.role;
  
  // Check if user has the required role
  if (userRole !== requiredRole) {
    // Log unauthorized access attempt
    console.warn(`Unauthorized access attempt: User role ${userRole} tried to access route requiring role ${requiredRole}`);
    // Redirect to home page if user doesn't have required role
    return <Navigate to="/" replace />;
  }
  
  // User has required role, render the protected component
  return children;
};

export default RoleProtectedRoute;
